module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Bold-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Bold-webfont.eot
// module id = 369
// module chunks = 0